"use client";

import { c as _c } from "react/compiler-runtime";
import { upload } from "@vercel/blob/client";
import { startTransition, useRef, useState } from "react";
import { fileDeleteAction } from "@/actions/file";
import { triggerNativeEvent } from "@/lib/utils";
export function useUpload(t0) {
  const $ = _c(19);
  const {
    clientPayload: t1,
    storeId,
    environment,
    bucket,
    defaultValue,
    onUpload
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? {} : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const clientPayload = t2;
  const inputFileRef = useRef(null);
  const hiddenInputRef = useRef(null);
  let t3;
  if ($[2] !== defaultValue) {
    t3 = defaultValue?.toString() ?? null;
    $[2] = defaultValue;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const [blobUrl, setBlobUrl] = useState(t3);
  const [progress, setProgress] = useState(0);
  const [isUploading, setIsUploading] = useState(false);
  let t4;
  if ($[4] !== bucket || $[5] !== clientPayload || $[6] !== environment || $[7] !== onUpload || $[8] !== storeId) {
    t4 = async () => {
      const file = inputFileRef.current?.files?.[0];
      if (!file) {
        return;
      }
      setIsUploading(true);
      setProgress(5);
      const path = `${bucket}/${storeId}/${environment}/${file.name}`;
      const newBlob = await upload(path, file, {
        access: "public",
        clientPayload: JSON.stringify(clientPayload),
        handleUploadUrl: "/admin/api/large-file-upload",
        multipart: true,
        onUploadProgress(e) {
          setProgress(p => Math.max(e.percentage, p));
        }
      });
      setIsUploading(false);
      setBlobUrl(newBlob.url);
      onUpload?.(newBlob.url);
    };
    $[4] = bucket;
    $[5] = clientPayload;
    $[6] = environment;
    $[7] = onUpload;
    $[8] = storeId;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const handleFileChange = t4;
  let t5;
  if ($[10] !== blobUrl || $[11] !== defaultValue) {
    t5 = () => {
      setBlobUrl(null);
      setProgress(0);
      setIsUploading(false);
      if (inputFileRef.current) {
        inputFileRef.current.value = "";
      }
      if (hiddenInputRef.current) {
        triggerNativeEvent(hiddenInputRef.current, "");
      }
      if (blobUrl && defaultValue !== blobUrl) {
        startTransition(async () => {
          await fileDeleteAction({
            fileUrl: blobUrl
          });
        });
      }
    };
    $[10] = blobUrl;
    $[11] = defaultValue;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const handleRemoveFile = t5;
  let t6;
  if ($[13] !== blobUrl || $[14] !== handleFileChange || $[15] !== handleRemoveFile || $[16] !== isUploading || $[17] !== progress) {
    t6 = {
      inputFileRef,
      hiddenInputRef,
      blobUrl,
      progress,
      isUploading,
      handleFileChange,
      handleRemoveFile
    };
    $[13] = blobUrl;
    $[14] = handleFileChange;
    $[15] = handleRemoveFile;
    $[16] = isUploading;
    $[17] = progress;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  return t6;
}